export default __webpack_public_path__ + "static/media/ic-damage-cover.35b86eaa.svg";